import { render, staticRenderFns } from "./gc-autocomplete-item-template.vue?vue&type=template&id=5c21220c"
import script from "./gc-autocomplete-item-template.vue?vue&type=script&lang=js"
export * from "./gc-autocomplete-item-template.vue?vue&type=script&lang=js"
import style0 from "./gc-autocomplete-item-template.vue?vue&type=style&index=0&id=5c21220c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports